const GOOGLE_DRIVE_FILE_SCOPE = 'https://www.googleapis.com/auth/drive.file';

/**
 * Must stay in sync with the backend GET_CONNECTION_URL scope list.
 * If a scope is added to the backend OAuth URL for an integration,
 * add it here so denied granular permissions are caught before
 * CREATE_CONNECTION burns the code.
 */
export const REQUIRED_OAUTH_SCOPES_BY_INTEGRATION: Readonly<Record<string, readonly string[]>> = {
  GOOGLEFORMS: [GOOGLE_DRIVE_FILE_SCOPE],
  GOOGLESHEETS: [GOOGLE_DRIVE_FILE_SCOPE],
};

export function missingRequiredOAuthScopes(
  integrationId: string | null | undefined,
  queryParams: Record<string, unknown> | null | undefined,
): string[] {
  const requiredScopes = REQUIRED_OAUTH_SCOPES_BY_INTEGRATION[(integrationId ?? '').toUpperCase()] ?? [];
  if (requiredScopes.length === 0) return [];

  const grantedScopes = parseGrantedOAuthScopes(queryParams?.['scope']);
  return requiredScopes.filter(scope => !grantedScopes.has(scope));
}

export function parseGrantedOAuthScopes(rawScope: unknown): Set<string> {
  const raw = Array.isArray(rawScope)
    ? rawScope.join(' ')
    : typeof rawScope === 'string'
      ? rawScope
      : '';

  const decoded = safeDecodeURIComponent(raw.replace(/\+/g, ' '));
  return new Set(
    decoded
      .split(/\s+/)
      .map(scope => scope.trim())
      .filter(Boolean),
  );
}

function safeDecodeURIComponent(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}
